var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSanitaryPipes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1151_48233)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1151_48233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34814 1.7121H38.5151V38.8786H1.34814V1.7121Z",
    fill: "#FCD385"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1151_48233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5151 20.2953C38.5151 30.5586 30.1946 38.8786 19.9314 38.8786C9.66813 38.8786 1.34814 30.5586 1.34814 20.2953C1.34814 10.0321 9.66813 1.7121 19.9314 1.7121C30.1946 1.7121 38.5151 10.0321 38.5151 20.2953Z",
    fill: "#FCD385"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40674 18.182V20.2595C8.40674 20.2595 8.50923 21.1511 9.11547 21.3653C9.11547 21.3653 8.58047 21.5795 8.61632 22.257L8.97299 25.9679C8.97299 25.9679 8.8305 26.6463 9.79386 27.2172L20.8545 33.7106C20.8545 33.7106 23.6729 35.6378 26.8489 34.1031C26.8489 34.1031 27.491 34.1031 28.5968 32.3548L29.7748 30.0714C29.7748 30.0714 30.5598 27.6446 30.2027 26.8246C30.2027 26.8246 33.2123 24.3505 33.2242 22.2156L8.40674 18.182Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9301 30.7392C16.9301 30.7392 16.02 26.4767 13.3267 24.8979C13.3267 24.8979 11.4712 24.3983 10.8291 26.9671L16.9301 30.7392Z",
    fill: "#B7B7B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.548 20.6207V19.5572C33.5591 19.4087 33.5577 19.2639 33.548 19.1219V19.0975L33.5462 19.0985C33.4166 17.4558 31.9872 16.2994 31.9872 16.2994L20.9977 10.0546L20.2692 9.59083L16.7164 8.27081L5.83313 13.92C5.66904 13.9967 5.59872 14.1158 5.58218 14.2523L5.57666 14.2477V15.9988L5.60975 16.0227C5.72787 16.4318 6.11901 16.8698 6.11901 16.8698L19.2493 24.4006C22.1394 25.9013 23.0669 25.6829 23.0669 25.6829C29.8463 26.2184 31.4159 24.2204 31.4159 24.2204C32.917 23.1155 33.4704 22.0281 33.5466 21.0698L33.548 21.0711V21.056C33.5591 20.908 33.5577 20.7623 33.548 20.6207Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.997 10.0546L31.9865 16.2985C31.9865 16.2985 35.8757 19.4386 31.4156 22.7211C31.4156 22.7211 29.846 24.7191 23.0667 24.1841C23.0667 24.1841 22.1387 24.402 19.2486 22.9018L6.11876 15.3709C6.11876 15.3709 5.12001 14.2532 5.8338 13.9199L16.7161 8.27124L20.2694 9.5908L20.9975 10.055L20.997 10.0546Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1151_48233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 15,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17773 0H20.0462V16.5609H6.17773V0Z",
    fill: "#D8D8D8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1151_48233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0463 9.61474V2.28844C20.0463 2.28844 20.0463 1.62246 19.5228 1.40828C18.9997 1.19455 17.2394 0.243147 17.2394 0.243147C17.2394 0.243147 16.2402 -0.303797 15.0273 0.243147C13.8139 0.790092 7.58192 4.21562 7.58192 4.21562C7.58192 4.21562 6.67786 4.63846 6.60662 6.18737L6.17871 14.1337C6.17871 14.1337 6.15481 14.5143 6.44069 14.7284C6.72612 14.9426 9.4374 16.4649 9.4374 16.4649C9.4374 16.4649 9.9848 16.679 10.5083 16.4649L19.6423 11.2556C19.6423 11.2556 20.0467 11.0184 20.0467 9.61474",
    fill: "#D8D8D8"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96144 7.54505C8.96144 7.54505 9.79427 8.23493 10.9121 7.66455L20.0465 2.47823C20.0465 2.47823 20.1003 1.67988 19.523 1.40733L17.2391 0.243117C17.2391 0.243117 16.0653 -0.275331 15.027 0.243117L7.58213 4.21513C7.58213 4.21513 6.58292 4.73311 6.60636 6.18688L8.96144 7.54505Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.794 7.89026V16.5471C9.794 16.5471 9.48927 16.4952 9.12388 16.2888L6.43972 14.7284C6.43972 14.7284 6.23748 14.574 6.17773 14.1342L6.60656 6.18646L8.96117 7.54509C8.96117 7.54509 9.45526 7.81305 9.794 7.89026Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6536 14.3543C25.6536 14.3543 31.8621 16.941 31.1065 19.6528C31.1065 19.6528 30.0604 23.1495 23.3762 22.8875C23.3762 22.8875 22.3297 22.9353 20.7118 22.3172L16.1212 19.5815C16.1212 19.5815 15.9419 18.6182 16.1212 17.2972C16.1212 17.2972 17.5901 14.5855 24.5418 13.9204L25.6536 14.3543Z",
    fill: "#D8D8D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8232 19.9993C16.8232 19.9993 17.9769 17.7022 21.5917 19.0585C25.2075 20.4139 22.9715 22.1742 22.9715 22.1742C22.9715 22.1742 22.6865 22.6256 21.2112 22.5309L20.6697 22.2919L16.8232 19.9993Z",
    fill: "#B4B8C1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8218 20.6041C17.8218 20.6041 18.155 18.4633 21.3424 19.6054C21.3424 19.6054 23.5072 20.7232 21.842 21.7697C21.842 21.7697 21.4183 22.1232 20.4669 22.1705L17.8218 20.6041Z",
    fill: "#747389"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 13.92V15.7038C24.5417 15.7038 18.8806 15.0143 16.1215 19.5811C16.1215 19.5811 15.8416 18.279 16.1215 17.2977C16.1215 17.2977 18.1962 14.1222 24.5417 13.92Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.542 13.92V15.7038C24.542 15.7038 29.4539 16.941 31.1067 19.6528C31.1067 19.6528 32.4152 16.3224 24.542 13.92Z",
    fill: "#D8D8D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3534 28.2517C22.3534 28.2517 27.1831 29.5722 30.2873 26.7534C30.2873 26.7534 30.5953 31.1956 27.8652 33.6039C27.8652 33.6039 24.0485 37.1003 17.5371 31.7485C17.5371 31.7485 23.7093 34.4602 23.2097 32.141C22.7101 29.8218 22.3534 28.2517 22.3534 28.2517Z",
    fill: "#C4C4C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25879 20.0618C9.25879 20.0618 20.6407 30.3926 22.7816 31.8197Z",
    fill: "#BCBEC6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8633 26.7529L16.5376 29.4288C16.5376 29.4288 15.4134 26.0391 13.3267 24.8974C13.3267 24.8974 12.2916 24.8621 11.8633 26.7529Z",
    fill: "#747389"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8138 3.14472C13.8138 3.35477 13.4944 3.52529 13.1005 3.52529C12.7062 3.52529 12.3867 3.35523 12.3867 3.14472C12.3867 2.93422 12.7062 2.76416 13.1005 2.76416C13.4944 2.76416 13.8138 2.93422 13.8138 3.14472Z",
    fill: "#E0E0DF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1151_48233",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 35,
    width: 13,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 35.4001H27.2407V40H15.7227V35.4001Z",
    fill: "#B7B7B7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1151_48233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.869 37.0713L23.8995 35.5909C22.6718 35.0895 20.877 35.7361 20.877 35.7361L16.0497 38.2535C15.7394 38.3684 15.6305 38.8464 15.8061 39.3225C15.9826 39.7982 16.3774 40.0901 16.6881 39.9752C16.734 39.9577 16.7754 39.9292 16.8122 39.8971C17.4602 39.4926 20.4845 37.6082 21.253 37.1849C22.1143 36.7096 23.2822 37.046 23.2822 37.046L26.2168 38.725C26.2798 38.7903 26.3547 38.8353 26.4398 38.8528C26.7642 38.9194 27.1099 38.5706 27.2119 38.0742C27.3075 37.6086 27.1554 37.178 26.869 37.0713Z",
    fill: "#B7B7B7"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1725 38.0637C27.0778 38.5256 26.7579 38.8501 26.4578 38.7889C26.1577 38.7269 25.9917 38.3027 26.0864 37.8407C26.1811 37.3788 26.501 37.0539 26.8011 37.1155C27.1012 37.1771 27.2676 37.6017 27.1725 38.0637ZM16.8922 38.9181C17.0563 39.3602 16.9566 39.8051 16.6689 39.9118C16.3821 40.0175 16.0162 39.7459 15.8521 39.3032C15.6885 38.8611 15.7882 38.4162 16.0755 38.31C16.3628 38.2034 16.7286 38.4755 16.8922 38.9181Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1151_48233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanitaryPipes);
export default __webpack_public_path__ + "static/media/sanitary-pipes.7d2fad04997f131b5a4d9e57c8c7e3c4.svg";
export { ForwardRef as ReactComponent };